/**
 * Converts a base64 data URL to a File object.
 * @param dataurl The base64 data URL.
 * @param filename The desired filename for the output File.
 * @returns A File object, or null if conversion fails.
 */
export const dataURLtoFile = (
    dataurl: string,
    filename: string
): File | null => {
    const arr = dataurl.split(",");
    if (arr.length < 2) {
        return null;
    }
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch || mimeMatch.length < 2) {
        return null;
    }
    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};

/**
 * Retrieves the form structure for the currently active form version.
 * @param form The main form state object containing form_entry_form_versions.
 * @returns The form structure object, or null if not found.
 */
export const getCurrentFormStructure = (form: any) => {
    if (!form) return null;
    // Get the current form version from form_entry_form_versions
    const currentFormVersion = form.form_entry_form_versions.find(
        (fv: any) => fv.id === form.id
    );

    if (!currentFormVersion) {

        return null;
    }

    return currentFormVersion.form_structure;
};
